import BasicLayout from '../layouts/BasicLayout';
import Home from '../pages/Home';
import NotFound from '../pages/NotFound';
import Payment from '../pages/Payment/Payment';
import QrScanner from '../pages/QrScanner/QrScanner';
import PaymentStation from '../pages/Home/PaymentStation';
import FindMyCarStation from '../pages/Home/FindMyCarStation';
import NumberPlate from '../pages/QrScanner/NumberPlate';
import TicketNumber from '../pages/QrScanner/TicketNumber';
import FindMyCarByQrScanner from '../pages/FindMyCar/FindMyCar';
import ScanPayment from '../pages/Payment/ScanPage';
import PosPayment from '../pages/PosPayment/PosPayment';
import PosPaymentStatus from '../pages/PosPayment/PaymentStatus';
import Services from '../pages/Services/Services';
import Details from '../pages/UserDetails/UserDetails';
import TicketGenerate from '../pages/UserDetails/TicketGenerate';
import AddVasTicket from '../pages/QrScanner/AddVasTicket';
import Settings from '../pages/Settings/Settings';

export default [
  {
    path: '/',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/paymentstation',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <PaymentStation />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/services',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Services />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/addVas',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <AddVasTicket />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/settings',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Settings />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/userDetails',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Details />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/booking',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <TicketGenerate />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/pospayment',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <PosPayment />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/pospaymentstatus',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <PosPaymentStatus />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },

  {
    path: '/findmycarstation',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <FindMyCarStation />,
      },
      {
        path: '/findmycarstation/findmycar',
        element: <FindMyCarByQrScanner />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/payment',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <Payment />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/numberplate',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <NumberPlate />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/ticketnumber',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <TicketNumber />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/payment/scan',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <ScanPayment />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/qrScanner',
    element: <BasicLayout />,
    children: [
      {
        index: true,
        element: <QrScanner />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];
